import cpSite from './cpSite'

/**
 * Включение одноколоночного режима
 */
const viewOneColumn = {
  // Активация скрипта
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: viewOneColumn')
    }
    document.getElementById('main').classList.toggle('one-column')
  },
  /* integrate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('integrate: viewOneColumn')
    }
    // Вар.1
    // document.write('<body style="display: none;">') todo: проверить упрощение в IE11 и т.п.
    /!*document.write('</head><body style="display: none;"></body>')
    document.addEventListener('DOMContentLoaded', function () {
      document.getElementById('main').classList.add('one-column')
      document.body.attributes.removeNamedItem('style')
    })*!/

    // Вар.2
    /!* document.addEventListener('DOMContentLoaded', function () {
      document.body.style.display = 'none'
      setTimeout(() => {
        document.getElementById('main').classList.add('one-column')
        document.body.attributes.removeNamedItem('style')
      }, 0)
    }) *!/
  }, */
  // Извлечение текущего состояния
  state: {
    get isActive () {
      return document.getElementById('main')?.classList.contains('one-column') ?? false
    }
  }
}
export default viewOneColumn
